import { Avatar, Box, Card, Heading, Icon, Image, Tag, Text } from '@zillow/constellation-10';
import { IconHomeTypeFilled } from '@zillow/constellation-icons';
import { TourStatusForZcheduler } from '@zg-rentals/ts-z-calendar-client';

const getTourStatusTone = (tourStatus?: TourStatusForZcheduler) => {
  switch (tourStatus) {
    case TourStatusForZcheduler.CONFIRMED:
      return 'green';
    case TourStatusForZcheduler.DECLINED:
      return 'red';
    case TourStatusForZcheduler.REQUESTED:
      return 'blue';
    case TourStatusForZcheduler.EXPIRED:
      return 'yellow';
    default:
      return 'purple';
  }
};

type EventDetailsProps = {
  bookedByName?: string;
  eventDateAndTime: string;
  listingStreet: string;
  photoUrl?: string;
  title: string;
  tourStatus?: TourStatusForZcheduler;
};

const EventDetails = ({
  bookedByName,
  eventDateAndTime,
  listingStreet,
  photoUrl,
  title,
  tourStatus,
}: EventDetailsProps) => {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }} data-testid="EventDetails">
      <Box css={{ display: 'flex', flexDirection: 'row', gap: 'default' }}>
        {photoUrl ? (
          <Image
            alt={`Photo of ${listingStreet}`}
            css={{ borderRadius: '12px', objectFit: 'cover', overflow: 'hidden', height: '72px', width: '72px' }}
            src={photoUrl}
          />
        ) : (
          <Icon css={{ borderRadius: '12px', height: '72px', width: '72px' }}>
            <IconHomeTypeFilled />
          </Icon>
        )}
        <Box>
          <Tag tone={getTourStatusTone(tourStatus)} css={{ marginBottom: 'tightest' }} size="sm">
            {title}
          </Tag>
          <Heading level={6}>{eventDateAndTime}</Heading>
          <Text textStyle="body-sm">{listingStreet}</Text>
        </Box>
      </Box>
      {bookedByName && (
        <Card elevated={false}>
          <Box css={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 'tighter' }}>
            <Avatar fullName={bookedByName} size="xs" />
            <Text>{bookedByName}</Text>
          </Box>
        </Card>
      )}
    </Box>
  );
};

export default EventDetails;
